import MlcTooltip from '@Components/Tooltips/MlcTooltip'
import React, { PropsWithChildren } from 'react'
import './index.scss'
import { PlacesType } from 'react-tooltip'

interface MenuPopoverProps {
    menuId: string
    isOpen: boolean
    place?: PlacesType
}

const MenuPopover = (props: PropsWithChildren<MenuPopoverProps>) => {
    const { menuId, isOpen, place, children } = props
    return (
        <MlcTooltip
            id={menuId}
            variant="light"
            className="popover-wrapper"
            isOpen={isOpen}
            openEvents={{ click: true }}
            clickable
            place={place}
        >
            <div className="menu-popover">
                <div className="popover-content">{children}</div>
            </div>
        </MlcTooltip>
    )
}

export default MenuPopover
